import { computed, type ComputedRef } from 'vue'
import { useAccountStatusQuery } from '../api/queries/useAccountStatusQuery'

export interface AccountAccessRestriction {
  // True when the signed-in investor's account access has been restricted
  // (blocked-but-verified). Consumers swap financial-action CTAs for a
  // contact-support blocker while keeping content browsable.
  isRestricted: ComputedRef<boolean>
}

// Single source of truth for the "account access restricted" gate, read from
// the primed account-status cache. The backend now computes the flag
// (`accessRestricted`), so the client no longer re-derives it from
// investorStatus. Consumed by the app-shell banner and every financial-action
// surface (dashboard, wallet, bank, invest).
export function useAccountAccessRestriction(): AccountAccessRestriction {
  const accountStatusQuery = useAccountStatusQuery()

  const isRestricted = computed(() => accountStatusQuery.data.value?.accessRestricted ?? false)

  return { isRestricted }
}
